// Phase 0 (ngUpgrade) — module bootstrap shim.
//
// Under the old Gulp build, `bower_components` libraries and the app files were
// simply concatenated into one global scope, so `angular`, the AngularJS plugins,
// and the `app`/`_pb` globals were implicitly shared by every file.
//
// Webpack gives every file its own module scope, so we recreate that shared world
// here:
//   1. Side-effect import every vendored library, IN THE EXACT ORDER that
//      `main-bower-files` fed Gulp (so behavior is identical), which registers
//      each AngularJS plugin module onto the global `angular`.
//   2. Define the `UmsApp` module and export `app` / `_pb`, which webpack's
//      ProvidePlugin then injects into the ~318 app files as ambient globals.
//
// Vendored straight from bower_components (not npm) to guarantee zero version
// drift from the current production bundle.

// Loads angular core FIRST and sets window.angular. `angular` below is then
// supplied to this module by ProvidePlugin (-> _angular -> window.angular).
import './_angular.js';

// ---- AngularJS plugins (exact main-bower-files order) ----
import '../../bower_components/lodash/lodash.js';
// ngUpgrade Phase 2: ui-router 0.3.2 → @uirouter/angularjs 1.x (registers the `ui.router`
// AngularJS module). The Angular-side bridge module `ui.router.upgrade` is registered as a
// side effect of importing @uirouter/angular-hybrid in app.module.ts (before bootstrap).
import '@uirouter/angularjs';
import '../../bower_components/angular-animate/angular-animate.js';
import '../../bower_components/angular-aria/angular-aria.js';
import '../../bower_components/angular-messages/angular-messages.js';
import '../../bower_components/angular-toastr/dist/angular-toastr.tpls.js';
import '../../bower_components/angular-bootstrap/ui-bootstrap-tpls.js';
import '../../bower_components/jquery/dist/jquery.js';
import '../../bower_components/angular-translate/angular-translate.js';
import '../../bower_components/angular-translate-loader-url/angular-translate-loader-url.js';
import '../../bower_components/angular-translate-loader-static-files/angular-translate-loader-static-files.js';
import '../../bower_components/trix/dist/trix.js';
import '../../bower_components/angular-sanitize/angular-sanitize.js';
import '../../bower_components/moment/moment.js';
import '../../bower_components/angular-svg-round-progressbar/build/roundProgress.js';
import '../../bower_components/angular-ui-tree/dist/angular-ui-tree.js';
import '../../bower_components/angular-md5/angular-md5.js';
import '../../bower_components/bootstrap/dist/js/bootstrap.js';
import '../../bower_components/angular-bootstrap-checkbox/angular-bootstrap-checkbox.js';
import '../../bower_components/angular-trix/dist/angular-trix.js';
import '../../bower_components/angular-ui-tinymce/src/tinymce.js';
import '../../bower_components/socket.io-client/dist/socket.io.js';
// NOTE: ngQuill is intentionally NOT imported — it is a CommonJS module requiring
// `quill` (which was never bundled), and 'ngQuill' is not a dependency of UmsApp
// (it was already commented out in the original index.js). So it was dead code.

// `angular` is injected by ProvidePlugin at build time.
declare const angular: any;

// Same module definition that lived in static-src/app/index.js.
export const app = angular.module('UmsApp', [
    'ui.bootstrap',
    'ngMessages',
    'ngAnimate',
    'ui.router',
    'ui.router.upgrade',
    'templates',
    'toastr',
    'pascalprecht.translate',
    'ui.checkbox',
    'angularTrix',
    'ngSanitize',
    'angular-svg-round-progressbar',
    'ui.tree',
    'angular-md5',
    'ui.tinymce',
]);

// Template-base path used throughout the app (templateUrl: _pb + '...').
export const _pb = '/app/';
